module.exports = __webpack_public_path__ + "static/media/Microsoft Lumia 950 White.0113152f.png";